import styled from 'styled-components';

export default styled.div`
  padding: 32px 0 40px 0;
`;
